import type { BrandProfile } from './types';

/** Default brand — VNETWORK. Selected when `APP_BRAND` is unset or 'vnetwork'. */
export const vnetwork: BrandProfile = {
  id: 'vnetwork',
  legalName: 'VNETWORK JOINT STOCK COMPANY.',
  shortName: 'VNETWORK',
  appName: 'Partner',
  ssoName: 'VNETWORK-ID',
  paymentReceiver: 'CONG TY CO PHAN VNETWORK',
  since: 2013,

  emails: {
    support: 'support@vnetwork.vn',
    sales: 'sales@vnetwork.vn',
    legal: 'legal@vnetwork.vn',
    care: 'cskh@vnetwork.vn',
  },

  hotline: '+84 (028) 7306 8789',

  urls: {
    docs: 'https://docs.vnetwork.vn',
    openapi: 'https://openapi.vnetwork.vn',
    postman: 'https://postman.vnetwork.dev/view/4429080/2sBY4Qqyts',
    privacyPolicy: 'https://www.vnetwork.vn/en-US/privacy-policy/',
  },

  assets: {
    logo: '/assets/img/logo.png',
    icon: '/assets/img/icon.png',
  },

  // GTM container for the Partner console (partner.vnetwork.vn).
  gtmContainerId: 'GTM-5H727DFT',

  promos: {
    wafFree: true,
  },

  features: {
    payments: true,
    sso: true,
    credit: true,
    livechat: true,
    documentation: true,
    support: true,
    billing: true,
    apiKeys: true,
    affiliate: true,
  },
};
